import React, { useState } from 'react';
import { View, StyleSheet, Platform, Linking } from 'react-native';
import { Card, CardContainer, Text, Rating, Colors, getSpacing, Image, getRadius, Button, Tag } from '@rahtab/ui';
import LocationIcon from '@rahtab/ui/dist/icons/LocationIcon';
import { useViewerEntity } from '@rahtab/auth/lib/token-based-auth';

const defaultProvider = require('assets/images/defaultProvider.png');

const dialCall = (supportNumber: string) => {
  let phoneNumber = '';
  if (Platform.OS === 'android') {
    phoneNumber = `tel:${supportNumber}`;
  } else {
    phoneNumber = `telprompt:${supportNumber}`;
  }
  Linking.openURL(phoneNumber);
};

const ProviderHeaderCard: React.VFC<ProviderHeaderCardProps> = ({
  premiumProvider,
  id,
  image,
  name,
  rateCount = 0,
  rate = 0,
  callNumber,
  city,
  ranking,
}) => {
  const [imageHeight, setImageHeight] = useState(0);
  const [imageSizeIsSet, setImageSizeIsSet] = useState(false);
  const { viewerSelectedEntity } = useViewerEntity();
  return (
    <Card>
      <CardContainer>
        <View style={styles.container}>
          <Image
            style={StyleSheet.flatten([{ height: imageHeight, width: imageHeight }])}
            source={image ? { uri: image } : defaultProvider}
            defaultSource={defaultProvider}
            resizeMode="cover"
            variant="outlined"
          />
          <View
            style={styles.leftView}
            onLayout={(event) => {
              const size = event.nativeEvent.layout.height;
              if (size > imageHeight && !imageSizeIsSet) {
                setImageHeight(size);
                setImageSizeIsSet(true);
              }
            }}>
            <Text color="primary" variant="title" numberOfLines={1}>
              {name}
            </Text>
            <View style={styles.secondLine}>
              <Text color="description">
                شناسه:
                <Text> {id}</Text>
              </Text>
              {typeof ranking === 'number' && (
                <Tag
                  text={viewerSelectedEntity?.label || ''}
                  backgroundColor={ranking === 0 ? 'default' : 'green'}
                  color={ranking === 0 ? 'default' : 'white'}>
                  <Text margin="none" color={ranking === 0 ? 'secondary' : 'white'}>
                    {ranking === 0 ? ' پایه' : ' ممتاز'}
                  </Text>
                </Tag>
              )}
            </View>
            <Rating count={isNaN(rateCount) ? 0 : rateCount} value={rate} />
          </View>
        </View>
        {!!city && (
          <View style={styles.locationView}>
            <LocationIcon style={styles.locationIcon} />
            <Text margin="none">{city}</Text>
          </View>
        )}
        {callNumber && (
          <Button
            text="تماس با تامین کننده"
            color="primary"
            variant="outlined"
            onPress={() => {
              dialCall(callNumber);
            }}
          />
        )}
      </CardContainer>
    </Card>
  );
};

export default ProviderHeaderCard;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  leftView: {
    flex: 1,
    marginLeft: getSpacing(),
  },
  secondLine: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  premimumView: {
    backgroundColor: Colors.lightgrey,
    alignItems: 'center',
    justifyContent: 'center',
    // marginBottom: getSpacing(),
    // padding: getSpacing(0.5),
  },
  locationView: {
    marginTop: getSpacing(),
    flexDirection: 'row',
    alignItems: 'center',
  },
  locationIcon: {
    height: 16,
    width: 16,
    marginRight: getSpacing(),
  },
  flex: {
    flex: 1,
  },
});

interface ProviderHeaderCardProps {
  name?: string;
  id?: string;
  rate?: number;
  rateCount?: number;
  premiumProvider?: boolean;
  image?: string;
  city?: string;
  callNumber?: string;
  ranking?: 0 | 1;
}
